import React, { memo } from 'react';
import { AlertTriangle, Clock, Lock } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-white-soft section-padding" data-id="element-208">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-209">
        La bomba de tiempo digital que estás dejando
      </h2>

      <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-210">
        <div className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-navy" data-id="element-211">
          <AlertTriangle className="w-12 h-12 text-gold mb-6" data-id="element-212" />
          <h3 className="text-xl font-bold mb-4" data-id="element-213">Métodos Obsoletos</h3>
          <p className="text-gray-600" data-id="element-214">
            La mayoría de las personas de más de 50 años en USA confían en
            métodos que fallan cuando más se necesitan. Las libretas de papel se
            pierden o se vuelven ilegibles.
          </p>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-navy" data-id="element-215">
          <Lock className="w-12 h-12 text-gold mb-6" data-id="element-216" />
          <h3 className="text-xl font-bold mb-4" data-id="element-217">Sistemas Estrictos</h3>
          <p className="text-gray-600" data-id="element-218">
            Los sistemas modernos son tan estrictos que, sin una configuración
            previa, bloquean a los herederos legales por meses. Confiar en la
            memoria es arriesgado bajo estrés.
          </p>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-navy" data-id="element-219">
          <Clock className="w-12 h-12 text-gold mb-6" data-id="element-220" />
          <h3 className="text-xl font-bold mb-4" data-id="element-221">Pérdida Total</h3>
          <p className="text-gray-600" data-id="element-222">
            Si no has designado un "Contacto de Legado", tu familia no solo
            perderá fotos; perderá el control de cuentas bancarias, seguros y
            beneficios que tú construiste para ellos.
          </p>
        </div>
      </div>
    </section>;
}